import { colors, fonts, inputHint, radius } from '../../theme';

const styles = {
  input: {
    backgroundColor: 'white',
    color: 'white',
  },
  inputDark: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  // Dark TextField of the connected pages and the auth pages.
  textFieldDark: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: colors.background,
      color: colors.text,
      borderRadius: radius.input,
      fontFamily: fonts.text,
      fontSize: 14,
      '& fieldset': {
        borderColor: colors.border,
      },
      '&:hover fieldset': {
        borderColor: colors.borderHover,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.borderFocus,
        borderWidth: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: colors.textSecondary,
      fontFamily: fonts.text,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: colors.text,
    },
    '& .MuiInputBase-input::placeholder': {
      color: colors.textSubtle,
      opacity: 1,
    },
  },
  error: {
    color: colors.danger,
  },
  errorDark: {
    ...inputHint,
    color: colors.dangerText,
  },
  // Eye of a password field: discreet, white on hover.
  eye: {
    color: colors.textSubtle,
  },
  eyeDark: {
    color: colors.textSecondary,
    '&:hover': {
      color: colors.text,
      backgroundColor: colors.hoverItem,
    },
  },
};

export default styles;
